export default async (response) => response
